import { Reducer } from 'redux'
import { IAarZonderLocatieState } from '../interfaces'
import {
  ZonderLocatieActions,
  Actions,
} from '../actions/aarZonderLocatieAction'

const initialState: IAarZonderLocatieState = {
  loading: false,
  afleverafspraken: undefined,
  foutmelding: undefined,
}

export const aarZonderLocatieReducer: Reducer<
  IAarZonderLocatieState,
  ZonderLocatieActions
> = (state = initialState, action) => {
  switch (action.type) {
    case Actions.ClearDataResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.payload,
        afleverafspraken: null,
      }
    case Actions.GetAfleverafsprakenDataRequest:
      return {
        ...state,
        loading: true,
        foutmelding: null,
        afleverafspraken: null,
      }
    case Actions.GetAfleverafsprakenDataResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
        afleverafspraken: action.success ? action.payload : null,
      }
    default:
      // The following line guarantees that every action in the KnownAction union has been covered by a case above
      neverReached(action)
  }

  return state
}

// tslint:disable-next-line:no-empty
const neverReached = (never: never) => {}
